import { deleteCookie, getCookie } from 'cookies-next'
import { useCallback } from 'react'
import { useMutation } from '@apollo/client/react'
import { getNetworkStatusCode } from 'lib/helpers/getNetworkStatusCode/getNetworkStatusCode'
import { cookieKeys } from 'lib/consts/browserStorage'
import { getCurrentDomain } from '../../helpers/getCurrentDomain/getCurrentDomain'
import { logError } from '../../tracking/datadog'
import { forgetSocureSession } from '../../tracking/socure/socure'
import { DeleteTokenCookieHook_signOutDocument } from './useDeleteTokenCookie.graphql'

type Options = Parameters<typeof deleteCookie>[1]

export const useDeleteTokenCookie = () => {
  const [signOut] = useMutation(DeleteTokenCookieHook_signOutDocument)

  return useCallback(async () => {
    const token = getCookie(cookieKeys.token)

    if (!token) {
      return
    }

    try {
      await signOut()
    } catch (err) {
      if (getNetworkStatusCode(err) !== 401) {
        logError(err, { message: 'Failed to sign out' })
      }
    }

    const options: Options = {}

    // Look at the implementation for the setTokenCookie for
    // details on the "domain" and "path" props
    if (process.env.REDIRECT_TO_BRAND) {
      options.domain = getCurrentDomain()
      options.path = '/'
    }

    // make sure token without additional params is also deleted
    deleteCookie(cookieKeys.token)
    deleteCookie(cookieKeys.token, options)

    // End the Socure session too — the render path can't observe this deletion (see forgetSocureSession).
    void forgetSocureSession()
  }, [signOut])
}
